module.exports = __webpack_public_path__ + "static/media/test26-2.a8909e0d.jpeg";